<form [formGroup]="myTaskForm"> 

<mat-card class="slidecontent">
  <div class="docheader">

   <div class="marked">

    <div class="checktask">
      <mat-icon>check_circle_outline</mat-icon>
    </div>
    <div class="txt">
      Mark as complete
    </div>
   </div>

   <!-- <button mat-button color="primary" (click)="deleteTask()">
    <mat-icon>delete_outline</mat-icon> Delete
  </button> -->
          
   <span mat-icon-button [matMenuTriggerFor]="taskSubActions"
   ><mat-icon>more_vert</mat-icon></span
 >
 <mat-menu #taskSubActions="matMenu" xPosition="before">
   <button
     mat-menu-item
     (click)="addTaskOption('Assigned')"
   >
     Assign Task
   </button>
   <button
     mat-menu-item
     (click)="addTaskOption('Reminder')"
   >
     Add Reminder
   </button>
   <button
     mat-menu-item
     (click)="addTaskOption('Schedule')"
   >
     Schedule By
   </button>
   <button
     mat-menu-item
     (click)="addTaskOption('Attach')"
   >
     Attach Placeholder
   </button>
 </mat-menu>
    <div class="closedetail">
      <button mat-icon-button (click)="closedetail(close)" ><mat-icon>close</mat-icon></button>
    </div>

  </div>
  <div class="detailtabs userdetails" >
    <!-- <mat-tab-group animationDuration="0ms">
      <mat-tab label="Detail"> 
          
         

      </mat-tab>

      <mat-tab label="Notes">

        <div class="detail">
          <div class="history">
            <div class="title">
              <h3>Note History</h3>
              <span class="count">2</span>
            </div>
            <div class="historylist">
                <div class="list">
                  <div class="info noteby">
                    <p class="by">HankPym <span>11/30/2018</span></p>
                    <p>When two parties reach an agreement on a transaction 
                      that gives one party the capital to purchase a home or 
                      other form of property</p>
                  </div>
                  <button mat-icon-button>
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
                <div class="list">
                  <div class="info noteby">
                    <p class="by">HankPym <span>11/30/2018</span></p>
                    <p>When two parties reach an agreement on a transaction 
                      that gives one party the capital to purchase a home or 
                      other form of property</p>
                  </div>
                  <button mat-icon-button>
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>                  
            </div>
          </div>

        </div>

      </mat-tab>

    </mat-tab-group> -->
    <div class="detail">

      <div class="statusTaskList">
        <div class="statusTask divide">
          <mat-form-field appearance="fill">
            <mat-label>Select Status</mat-label>
            <mat-select value="Waiting" >
              <mat-option  value="">Waiting <mat-icon>task</mat-icon></mat-option>
              <mat-option  value="">In Progress</mat-option>
              <mat-option  value="">Declined</mat-option>
            </mat-select>
          </mat-form-field>
          
        </div>
        <div class="taskList divide">
          <button mat-stroked-button color="primary" (click)="addFolder(addFolderDialog)"> Task list<mat-icon>commit</mat-icon> status
          </button>
        </div>
      </div>

      <ng-container>
        <!-- <app-addtask></app-addtask>  -->
        <div class="createTask"> 
          <div class="block colorExternal">
            <div class="selectTaskColor">
              <div class="selectedColor" (click)="toggleColorSelection()">
                <span [ngStyle]="{ 'background-color': selectedColor }"></span>
                <mat-icon>arrow_drop_down</mat-icon>
              </div>
              <div class="colGroup" *ngIf="showColorPannel">
                <ng-container *ngFor="let color of colors; let i; as: index">
                  <label class="colm" [ngStyle]="{ 'background-color': color.colname }">
                    <input  type="radio" id="{{ i }}" type="radio" value="{{ color.colname }}"
                     (click)="SelectColor(color.colname)" name="noteColor"/>
                    <span class="checkmark"></span>
                  </label>
                </ng-container>
              </div>
            </div>
            <div class="extrnalTask">
              <mat-checkbox color="primary" formControlName="isInternal">External Task</mat-checkbox>
            </div>
          </div>
          <div class="block block_division">
            <mat-form-field class="taskTitle">
              <mat-label>Title</mat-label>
              <input matInput formControlName="title" maxlength="100" placeholder="Task Name"/>
            </mat-form-field>
      
            <mat-form-field class="dateInput">      
              <mat-label>Due date</mat-label>
                <input matInput [matDatepicker]="picker" formControlName="dueDate" readonly>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>      
            </mat-form-field>
          </div>
      
          <div class="block">
            <mat-form-field>
              <mat-label>Description</mat-label>
              <textarea matInput formControlName="description" maxlength="500"
                cdkTextareaAutosize
                cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="2">
              </textarea>
            </mat-form-field>
          </div>
      
        
        </div> 
      </ng-container>

       
      <ng-container >
       <app-task-assign></app-task-assign>
      </ng-container>

      <ng-container >
        <app-task-reminder></app-task-reminder>
      </ng-container>

      <ng-container >
        <app-task-schedule-by></app-task-schedule-by>
      </ng-container>

      <ng-container  >
        <app-task-attach-ccc></app-task-attach-ccc>
      </ng-container>
      
    </div>
  </div>
  <div class="actionBtn">
    
    <button mat-flat-button class="cancel" (click)="closedetail(close)"  >Cancel</button>
    <button mat-flat-button class="calltoaction" type="submit"  color="primary">Add</button>
    </div>
</mat-card>

<div class="documentOverlay"  (click)="closedetail(close)" ></div>



<ng-template #addFolderDialog>
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>description</mat-icon></span>
    Attach Task Template     
    <button mat-icon-button >
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <mat-dialog-content>
    <div class="statusArea">
      <div class="head">
        <select placeholder="Select Status">
          <option>Waiting</option>
          <option>In Progress</option>
          <option>Decline</option>
        </select>
        <div class="search">
          <input type="text" placeholder="Search task">
        </div>
      </div>
      <div class="taskList">
        <ul>
          <li>Finger Surgery <mat-icon>delete</mat-icon></li>
          <li>On Boarding User <mat-icon>delete</mat-icon></li>
          <li>Patient Reports Verifications <mat-icon>delete</mat-icon></li>
        </ul>
      </div>
    </div>
    <div class="statusArea">
      <div class="head">
        <select>
          <option>Waiting</option>
          <option>In Progress</option>
          <option>Decline</option>
        </select>
        <div class="search">
          <input type="text" placeholder="Search task">
        </div>
      </div>
      <div class="taskList">
        <ul>
          <li>Finger Surgery <mat-icon>delete</mat-icon></li>
          <li>On Boarding User <mat-icon>delete</mat-icon></li>
          <li>Patient Reports Verifications <mat-icon>delete</mat-icon></li>
        </ul>
      </div>
    </div>
    <button mat-icon-button color="primary" ><mat-icon>add_circle</mat-icon></button>
  </mat-dialog-content>
  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-flat-button  color="basic" > Cancel</button>
    <button mat-flat-button  color="primary"  >
      Attach
    </button>
  </mat-dialog-actions>
</ng-template>

